export default __webpack_public_path__ + "static/media/CarlosSlim.17f9ebef.jfif";